import styled from 'styled-components';
import { PALETTE_COLORS } from '@/constant/unit/color';
export const S = {
    Layout: styled.div `
    width: fit-content;
    padding: 3px 11px 5px;
    margin-left: 12px;

    font-size: 16px;
    color: ${PALETTE_COLORS.NEUTRAL_300};
    background: ${PALETTE_COLORS.PRIMARY_500};

    border-radius: 13px 13px 0 0;
  `,
};
